export const ADVANCE_PAYMENT_MIN_AMOUNT = 0.01;

/**
 * A special offer can stay flagged as a downpayment plan with a 0% advance.
 * Collection only starts when there is at least one cent to charge.
 */
export function requiresAdvancePayment(offer) {
  const isDownpaymentPlan = Boolean(
    offer?.isDownpaymentPlan ?? offer?.is_downpayment_plan
  );

  if (!isDownpaymentPlan) {
    return false;
  }

  const amount = Number(offer?.downpaymentAmount ?? offer?.downpayment_amount);

  return Number.isFinite(amount) && amount >= ADVANCE_PAYMENT_MIN_AMOUNT;
}

/**
 * Payment-status payload: `required` can stay true for a 0% special offer.
 * Collection is pending only when that flag comes with an amount to charge.
 */
export function requiresAdvanceCollection(downpayment) {
  if (!downpayment?.required) {
    return false;
  }

  const amount = Number(downpayment.expected_amount ?? downpayment.amount ?? 0);

  return Number.isFinite(amount) && amount >= ADVANCE_PAYMENT_MIN_AMOUNT;
}

/**
 * Seller handoff can leave PaymentStep when the card is linked.
 * A real advance also needs the collected downpayment confirmed.
 */
export function isSellerPaymentStepReady(statusData) {
  if (!statusData) {
    return false;
  }

  if (requiresAdvanceCollection(statusData.downpayment)) {
    return Boolean(statusData.downpayment?.ready);
  }

  return Boolean(statusData.card?.linked);
}
